const TITLE = 'チャットでお問い合わせ'
// const TITLE = '自然言語対話AIエンジン'
const SUB_TITLE = 'ユーザーアプリ'

// visibilitychangeイベント用
const STATE_VISIBLE = 'visible'
const STATE_HIDDEN = 'hidden'

export default {
  title: TITLE,
  subTitle: SUB_TITLE,
  stateVisible: STATE_VISIBLE,
  stateHidden: STATE_HIDDEN
}



// WEBPACK FOOTER //
// ./src/util/const.js